import { Action, Types } from "./planningImport.actions"

export type PlanningImportState = {
  errors: {}
  loading: boolean
}

const initialState: PlanningImportState = {
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): PlanningImportState => {
  switch (action.type) {
    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
